module.exports = __webpack_public_path__ + "images/150_2048.jpg";